import { SagaIterator } from 'redux-saga';
import { call, select } from 'redux-saga/effects';
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { isIProjectItemInfo } from '../../../ts/models/resourceInfoParts';
import { ContentActions } from '../../../ts/services/ContentActions';
import { NewFlowForDatasourceAction } from '../../actions/spaces/NewFlowForDatasourceAction';
import { SessionSiteSelectors } from '../../selectors/SessionInfoSelectors';
import { ServiceLocator } from '../../ServiceLocator';
import { getDatasourceDetailInfo, replaceDatasourceIdWithConnectionIdForMixedContent } from './SpacesSagaHelpers';

export function* handleNewFlowForDatasourceAction(action: NewFlowForDatasourceAction): SagaIterator {
  const siteUrlName: string = yield select(SessionSiteSelectors.siteUrlName);
  let projectId;
  if (isIProjectItemInfo(action.contentInfo)) {
    projectId = action.contentInfo.project.id;
  }
  const mutatableContentInfo: IContentInfo[] = yield call(replaceDatasourceIdWithConnectionIdForMixedContent, [action.contentInfo]);
  const datasourceDetailInfo = yield call(getDatasourceDetailInfo, mutatableContentInfo[0].id);
  ServiceLocator.get<ContentActions>('ContentActions').newFlow(siteUrlName, datasourceDetailInfo, projectId);
}
